import React, { Component } from "react";
import captureIcon from "../assets/icons/capture.svg";
import Repeatable from "react-repeatable";
import { connect } from "react-redux";

class WebCam extends Component {
  video = null;
  buttonStatus = false;
  _mountedState = false;
  constructor(props, context) {
    super(props, context);
    this.state = {
      imgData: null,
    };
  }

  // DRAWS IMAGE TO CANVAS AND SENDS
  capture = () => {
    let previewCanvas = document.createElement("canvas");
    let previewCtx = previewCanvas.getContext("2d");
    previewCanvas.width = 50;
    previewCanvas.height = 50;
    previewCanvas.style.objectFit = "cover";
    previewCanvas.style.marginRight = "7px";
    previewCanvas.style.borderRadius = "4px";
    previewCtx.drawImage(this.video, 0, 0, 50, 50);

    let trainingCanvas = document.createElement("canvas");
    let trainingCtx = trainingCanvas.getContext("2d");
    trainingCanvas.width = 224;
    trainingCanvas.height = 224;
    trainingCanvas.style.objectFit = "cover";
    trainingCtx.drawImage(this.video, 0, 0, 224, 224);

    this.props.parentCallBack(previewCanvas, trainingCanvas);
  };

  //RENDERS CAMERA ON LOAD
  renderCamera = () => {
    this.video = document.getElementById("video" + this.props.id);
    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        // First get ahold of the legacy getUserMedia, if present
        const getUserMedia =
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia;

        // Some browsers just don't implement it - return a rejected promise with an error
        // to keep a consistent interface
        if (!getUserMedia) {
          return Promise.reject(
            new Error("getUserMedia is not implemented in this browser")
          );
        }

        // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
        return new Promise(function (resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    }
    /* let supports = navigator.mediaDevices.getSupportedConstraints();
    if (!supports["frameRate"] || !supports["facingMode"]) {
      alert("Webcam does not support facingmode or framerate on this device");
    } else {
      frameRate = 60;
    } */
    navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: { height: 224, width: 224 },
      })
      .then((stream) => {
        if ("srcObject" in this.video) {
          this.video.srcObject = stream;
        } else {
          // Avoid using this in new browsers, as it is going away.
          this.video.src = window.URL.createObjectURL(stream);
        }

        return new Promise(
          (resolve) => (this.video.onloadedmetadata = resolve)
        );
      })
      .then(() => {
        if (!this.props.capture) this.getPreds(); //COMMENT THIS LINE TO DISABLE INFER_MODEL CALL
      })
      .catch((err) => {
        alert('DEVICE DOES NOT HAVE WEBCAM')
        console.log("An error occured: " + err);
      });
  };

  getPreds = async () => {
    await this.props.obj.infer_model(this.video).then(
      function (result) {
        this.props.sendPreds(result);
      }.bind(this)
    );
    //CONDITION TO QUIT INFERENCE FOR RETRAINING
    if (this._mountedState && !this.props.startStop)
      this.getPreds();
  };

  //DISABLE OPTIONS ON RIGHT CLICK AND HOLD
  disableRightClick = (e) => {
    e.preventDefault();
  };

  componentDidMount() {
    this.renderCamera();
    if (!this.props.capture) {
      this._mountedState = true;
      //this.getPreds()
    }
  }

  componentWillUnmount() {
    if(this.video.srcObject) {
      let track = this.video.srcObject.getTracks();
      track[0].stop();
    }
    this._mountedState = false;
  }

  render() {
    let captureBttn, caputerStyles, divStyles;
    if (this.props.capture) {
      captureBttn = (
        <Repeatable
          repeatDelay={300}
          repeatInterval={100}
          onHold={this.capture}
          onClick={this.capture}
        >
          <img
            src={captureIcon}
            style={{
              width: "35px",
              height: "35px",
              WebkitUserSelect: "none",
              WebkitTouchCallout: "none",
            }}
            onContextMenu={this.disableRightClick}
          />
        </Repeatable>
      );
    }
    if (this.props.device === 1) {
      caputerStyles = {
        zIndex: "1",
        position: "absolute",
        marginTop: "35px",
        marginLeft: "250px",
      };
      divStyles = {
        marginRight: "15px",
      };
    } else {
      caputerStyles = {
        zIndex: "1",
        position: "absolute",
        marginTop: "-40px",
        marginLeft: "317px",
      };
    }
    return (
      <div style={divStyles}>
        <center style={{ marginTop: "30px" }}>
          <video
            id={"video" + this.props.id}
            height="224px"
            width="224px"
            style={{ borderRadius: "4px" }}
            autoPlay
            playsInline
          ></video>
        </center>
        <div style={caputerStyles}>{captureBttn}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    startStop: state.startStop,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    //SEND PREDS TO STORE
    sendPreds: (preds) => {
      dispatch({
        type: "PREDICTION %",
        preds: preds,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WebCam);
